import { array, object, string } from 'yup'
import { FormSchema } from '../Wizard/Form/Types'
import { topic } from './shared/topic'
import { brandVoiceId, tone } from './shared/voiceTones'
import { avoid } from './shared/avoid'
import { audience } from './shared/audience'
import { language } from './shared/language'
import { PressRelease } from 'almanac-ui/icons/blaze/32'
import { safify } from './utils/safify'
import { sourceMaterialIds } from './shared/sourceMaterials'
import { ChannelType } from 'components/CampaignCreationModal/Types'
import { GenerationType } from 'components/BlazeCommandLine/api/createDocGenerationRequest'
import { includeImages } from './shared/includeImages'
import { additionalInfo } from './shared/additionalInfo'
import { productDescription } from './shared/productDescription'
import { MultiStepSchema, StepSchema } from 'components/Wizards/schemas/Types'
import { SelectImages } from 'components/Wizards/schemas/shared/selectImages'
import { brandKitId } from './shared/brandKitId'
import { TextChannels } from '../../../constants'

const meta = {
  type: ChannelType.PressRelease,
  icon: PressRelease,
  steps: ['Context', 'Generate Press Release'],
  title: TextChannels[ChannelType.PressRelease].name,
  submitLabel: 'Generate Press Release',
  previewUrl:
    'https://res.cloudinary.com/almanac/image/upload/v1710183790/Home%20Card%20Previews/xaa5adbpb63qsoukhhsx.png',
}

const fields = {
  topic: topic.meta({ label: 'What is the topic of your press release?', generationType: meta.type }),
  press_release_type: string()
    .default('')
    .required()
    .meta({
      label: 'What type of press release is this?',
      placeholder: 'E.g. New product announcement, event, fundraiser, quarterly results',
      autoFill: true,
    })
    .transform(safify),
  additional_info: additionalInfo
    .meta({
      label: 'Facts, notes, or quotes to include',
      collapsible: true,
    })
    .transform(safify),
  brand_voice_id: brandVoiceId,
  brand_kit_id: brandKitId,
  source_material_ids: sourceMaterialIds,
  include_images: includeImages,
  tone,
  language,
  mentions: array()
    .of(string())
    .default([])
    .meta({
      collapsible: true,
      label: 'People or entities to mention',
      mobilePlaceholder: 'People or entities to mention',
      placeholder: 'People or entities to include in your content',
      snippets: true,
      autoFill: true,
    })
    .transform(safify),
  audience: audience.meta({ collapsible: true }),
  product_description: productDescription.meta({ collapsible: true }),
  avoid: avoid.meta({ collapsible: true }),
}

export const PressReleaseSchema = object(fields).meta(meta) as FormSchema<GenerationType | ChannelType>

export const PressReleaseMultiStepSchema: MultiStepSchema<ChannelType.PressRelease> = {
  steps: [
    PressReleaseSchema.omit(['include_images']).meta({
      title: 'Purpose & Goals',
      submitLabel: 'Select Images',
    }) as StepSchema,
    SelectImages.meta({ submitLabel: meta.submitLabel, type: meta.type }) as StepSchema,
  ],
  meta: {
    ...meta,
    type: ChannelType.PressRelease,
    channel: ChannelType.PressRelease,
  },
}
